const list = {
  total: 4,
  list: [
    {
      id: 1,
      status: 0,
      name: 'All Permission',
      permission_list: [100, 110, 120, 130],
      permission_name_list: ['Lists', 'Normal', 'Nested', 'Parallel'],
      ctime: 1.5e9,
      mtime: 1.5e9
    },
    {
      id: 2,
      status: 0,
      name: 'Normal',
      permission_list: [100, 110],
      permission_name_list: ['Lists', 'Normal'],
      ctime: 1.5e9,
      mtime: 1.5e9
    },
    {
      id: 3,
      status: 0,
      name: 'Nested',
      permission_list: [100, 120],
      permission_name_list: ['Lists', 'Nested'],
      ctime: 1.5e9,
      mtime: 1.5e9
    },
    {
      id: 4,
      status: 0,
      name: 'Parallel',
      permission_list: [100, 130],
      permission_name_list: ['Lists', 'Parallel'],
      ctime: 1.5e9,
      mtime: 1.5e9
    }
  ]
}

export default { list }



// WEBPACK FOOTER //
// ./examples/mock/role.js